import { matchRoutes, useLocation, useOutletContext } from 'react-router-dom';
import { connect } from 'react-redux';
import { useAuth } from 'react-oidc-context';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import Container from '@mui/material/Container';
import DataTable from '../components/DataTable';
import Typography from '@mui/material/Typography';
import { Box, Button, Grid, Paper, Tooltip, alpha, darken, lighten, useMediaQuery, useTheme } from '@mui/material';
import { GridValueGetterParams } from '@mui/x-data-grid';
import Divider from '@mui/material/Divider';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';

import FilterData from './filterData';
import Header from '../components/Header';
import Styles from '../theme/commonCss/Styles';
import FileExport from './FileExport';
import FileImport from './FileImport';
import { palette } from '../theme/palette';
import AddButtonWithAccessCheck from '../components/AddButtonWithAccessCheck';
// import { routePaths } from '../utils/route-paths';
import { ReactComponent as VrLine } from '../assets/icons/main/verticalLine.svg';
import { ReactComponent as CloseIcon } from '../assets/icons/main/close-icon.svg';
import { ReactComponent as CheckIcon } from '../assets/icons/main/check-icon.svg';
import { ReactComponent as PreviewIcon } from '../assets/icons/main/preview-icon.svg';
import { ReactComponent as TemplateIcon } from '../assets/icons/main/template-icon.svg';
import SettingsIconButton from '../components/SettingsIconButton';
import EditIconButton from '../components/EditIconButton';
import DeleteIconButton from '../components/DeleteIconButton';
import ViewIconButton from '../components/ViewIconButton';
import SearchField from './searchField';
import PlayButton from '../components/PlayIconButton';
import EditDigitalTwin from '../components/EditDigitalTwin';
import CustomDataTable from '../components/CustomDataTable';
import { ReactComponent as ExcelIcon } from '../assets/icons/main/microsoft-excel-icon.svg';
import AccessButton from '../components/AccessButton';

const MasterComponent = ({
  heading,
  isLoading,
  showHeader,
  columns,
  rows,
  showFilters,
  showColumnFilters,
  setIsModalOpen = () => { },
  checkboxSelection,
  header,
  disableRowSelectionOnClick,
  onRowSelectionChange,
  showDeleteButton,
  ontologyData,
  deleteData,
  onRowClick,
  onOntoFilterChange,
  ontologyManagement,
  exportData,
  fileName,
  showImport,
  showExport,
  showSaveButton,
  disableSaveButton,
  disableSaveButtonTooltipText,
  excelSchema,
  imporAction,
  isTemplate,
  noRowsOverlay,
  isFromUserManagement,
  handleSave = () => { },
  pageSize,
  isFromUseCase,
  selectedTab,
  onStatusChange,
  hiddenColumns,
  selectionModel,
  isRowSelectable = () => { },
  handleRefresh = () => { },
  hideFooter,
  actionsColumn = {},
  otherProps = {},
  userAccess,
  isServerPagination,
  totalRowCount = 0,
  pageNumber,
  onPagination,
  tableHeight,
  onSorting,
  showSearch,
  searchPlaceholder = '',
  onSearch = () => { },
  isFromPart,
  isFromRoleAccess,
  isFromMachine,
  entityName,
  dataColumns,
  isFromSecrets,
  setTemplateModal = () => { },
  setSecretModal = () => { },
  loadCustomTable,
  isExpandable,
  expandedRows,
  onAddNewClick = () => { },
  showDownloadTemplate,
  onDownloadTemplate = () => { },
  addNewLabel = 'Add New',
  openBulkPopup,
  hideAddNewButton,
  isFromActivity,
  isFromBuilder,
  isFromGrfanaTemplate,
  useCaseBuilerAccess
}: any) => {
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const routePaths: any = get(useOutletContext(), 'combinedRoutePaths', [])

  const addNewService = () => {
    setIsModalOpen(true);
    onAddNewClick();
  };

  const { gateway, asset, service } = header || {};
  const auth = useAuth();
  const { pathname } = useLocation();

  const matchedRoute = matchRoutes(routePaths, pathname);
  const hasAccessTo = get(userAccess, `${get(matchedRoute, '[0].route.endPointPath', '')}`, {});

  const mdScreen = useMediaQuery('(max-width:1199px)');
  const tabSmallScreen = useMediaQuery('(max-width:999px)');
  const hideVerticalLine = useMediaQuery('(max-width:828px)');

  const leftGridColDef: any = {
    xl: (isFromUseCase || isFromGrfanaTemplate) ? 4 : isFromPart ? 4 : isFromRoleAccess ? 10 : 4,
    lg: (isFromUseCase || isFromGrfanaTemplate) ? 5.2 : isFromPart ? 12 : isFromRoleAccess ? 10 : isFromMachine ? 2 : 3,
    md: (isFromUseCase || isFromGrfanaTemplate) ? (selectedTab === 1 ? 6 : 12) : isFromPart ? 12 : isFromRoleAccess ? 8 : 4,
    sm: isFromRoleAccess ? 9 : 12,
    xs: 12
  }

  const rightGridColDef: any = {
    xl: (isFromUseCase || isFromGrfanaTemplate) ? 8 : isFromPart ? 8 : isFromRoleAccess ? 2 : 8,
    lg: (isFromUseCase || isFromGrfanaTemplate) ? 6.8 : isFromPart ? 12 : isFromRoleAccess ? 2 : isFromMachine ? 10 : 9,
    md: (isFromUseCase || isFromGrfanaTemplate) ? (selectedTab === 1 ? 8 : 12) : isFromPart ? 12 : isFromRoleAccess ? 4 : 8,
    sm: isFromRoleAccess ? 3 : 12,
    xs: 12
  }

  const pageStyles = {
    leftGridSX: {
      display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center',
      '@media (min-width:300px) and (max-width:1708px)': { alignItems: showImport ? 'baseline' : showDownloadTemplate ? 'flex-start' : 'center' },
      '@media (min-width:300px) and (max-width:899px)': { marginBottom: '16px' }
    },
    rightGridSX: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' },
    rightGridMachinePartSX: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', flexWrap: 'wrap', alignItems: 'center', gap: '16px' },
    rightGridCommonPages: {
      display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', flexWrap: 'wrap', alignItems: 'center',
      '@media (min-width:300px) and (max-width:899px)': { width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap', alignItems: 'center' },
    },
    rightGridContainer: { display: 'flex', '@media (max-width:999px)': { width: '100%' } },
    rightGridSearchBox: {
      display: 'flex',
      // marginRight: '16px',
      '@media (max-width:999px)': {
        width: '100%'
      },
    },
    rightGridFactoryUseCaseSX: {
      display: 'flex',
      flexDirection: 'row',
      paddingTop: '8px',
      paddingBottom: '8px',
      justifyContent: 'flex-end',
      flexWrap: 'wrap',
      alignItems: 'center',

      '@media (min-width:1201px)': {
        flexWrap: 'no-wrap',
        gap: '16px',
      },
      '@media (min-width:300px) and (max-width:1200px)': {
        paddingBottom: '16px',
        paddingTop: '16px',
        gap: '16px',
      },
      '@media (min-width:1201px) and (max-width:1421px)': {
        paddingTop: '20px',
        paddingBottom: '20px',
        gap: '10px'
      },
      '@media (min-width:300px) and (max-width:1199px)': {
        width: '100%',
      },
    },
    rightGridButton: {
      height: '42px',
    },
    rightGridTab2SX: {
      display: 'flex',
      gap: '16px',
      '@media (min-width:300px) and (max-width:899px)': {
        paddingBottom: '16px'
      },
    }
  }
  
  return (
    <Container maxWidth={false} disableGutters sx={Styles.masterContainer}>
      <Paper sx={{ ...Styles.masterPaperContainer, border: `1px solid  ${themeData.palette.customBorderColor.main}`, backgroundColor: 'transparent' }}>
        {showFilters === true && showFilters && ontologyData.length > 0 && (
          <Box sx={{ padding: '32px', borderBottom: `1px solid ${themeData.palette.customBorderColor.main}` }}>
            <FilterData
              ontologyManagement={ontologyManagement}
              ontologyData={ontologyData}
              showLayout={true}
              onOntoFilterChange={onOntoFilterChange}
              handleRefresh={handleRefresh}
            />
          </Box>
        )}
        <Box
          sx={{
            ...Styles.masterHeaderContainer,
            ...(isFromUserManagement || isFromUseCase || isFromBuilder ? { px: 3 } : { p: 3 }),
            backgroundColor: (themeMode.isLightBG) ? lighten(themeData.palette.background.default, 0.9) : lighten(themeData.palette.background.default, 0.05),
            borderTopLeftRadius: isFromMachine && isFromPart && isFromUseCase ? '0px' : showFilters ? '0px' : '18px',
            borderTopRightRadius: isFromMachine && isFromPart && isFromUseCase ? '0px' : showFilters ? '0px' : '18px',
          }}
        >

          {showHeader ? (
            <Header gateway={gateway} asset={asset} service={service} />
          ) : (
            <Grid container>
              <Grid
                item={true}
                xl={leftGridColDef.xl}
                lg={leftGridColDef.lg}
                md={leftGridColDef.md}
                sm={leftGridColDef.sm}
                xs={leftGridColDef.xs}
                sx={pageStyles.leftGridSX}
              >
                {isFromUserManagement || isFromUseCase ? (
                  heading
                ) : (
                  <Typography sx={{ ...Styles.tableTitle, color: themeData.palette.text.primary }}>{heading}</Typography>
                )}
              </Grid>
              <Grid
                item={true}
                xl={rightGridColDef.xl}
                lg={rightGridColDef.lg}
                md={rightGridColDef.md}
                sm={rightGridColDef.sm}
                xs={rightGridColDef.xs}
                sx={pageStyles.rightGridSX}
              >
                {isFromUseCase ? (
                  <> {
                    isFromSecrets ?
                      <Box sx={pageStyles.rightGridFactoryUseCaseSX}>
                        <SearchField searchPlaceholder={searchPlaceholder} onSearch={onSearch} inputWidth={mdScreen ? { width: '260px' } : { width: '260px' }} />
                        <VrLine style={{ color: `${themeData.palette.customBorderColor.main}` }} />
                        {selectedTab === 'secrets' ? <AddButtonWithAccessCheck from='MasterComponent' onClick={() => setSecretModal(true)} styles={{ marginRight: '0px', height: '42px' }} label={'New Secret'} />
                          : <AddButtonWithAccessCheck from='MasterComponent' onClick={() => setTemplateModal(true)} styles={{ marginRight: '0px', height: '42px' }} label={'New Template'} />}
                      </Box> : selectedTab === 0 ? (
                        <Box sx={pageStyles.rightGridFactoryUseCaseSX}>
                          {showSearch && (<SearchField searchPlaceholder={searchPlaceholder} onSearch={onSearch} inputWidth={mdScreen ? { width: '260px' } : { width: '260px' }} />)}
                          {(!hideVerticalLine && showSearch) && <VrLine style={{ color: `${themeData.palette.customBorderColor.main}` }} />}
                          {showDownloadTemplate &&
                            <Box sx={{ ml: 0 }}>
                              <Button variant='outlined' onClick={onDownloadTemplate} sx={{ height: '42px' }} startIcon={<TemplateIcon />}>
                                Download Template
                              </Button>
                            </Box>
                          }
                          <Button variant='outlined' color='primary' onClick={() => onStatusChange('waiting_for_approval')} sx={{ height: '42px' }} disabled={!hasAccessTo.update} >
                            <CheckIcon style={!hasAccessTo.update ? { filter: 'grayscale(100%)', opacity: 0.6 } : { marginRight: 1 }} /> Submit for Approval
                          </Button>
                          
                          <AddButtonWithAccessCheck from='MasterComponent' onClick={addNewService} styles={{ marginRight: '0px', height: '42px' }} />
                        </Box>
                      ) : hasAccessTo.approver ? (
                        <Box sx={pageStyles.rightGridTab2SX}>
                          {showSearch && (<SearchField searchPlaceholder={searchPlaceholder} onSearch={onSearch} inputWidth={mdScreen ? { width: '260px' } : { width: '260px' }} />)}
                          <Button variant='outlined' color='success' onClick={() => onStatusChange('approved')} sx={pageStyles.rightGridButton}>
                            <CheckIcon style={{ marginRight: 1, color: `${palette.success.dark} !important` }} /> Approve
                          </Button>
                          <Button variant='outlined' color='error' onClick={() => onStatusChange('rejected')} sx={pageStyles.rightGridButton} >
                            <CloseIcon style={{ marginRight: 1, color: palette.error.main }} /> Reject
                          </Button>
                        </Box>
                      ) : (
                        ''
                      )
                  }</>
                ) : (isFromMachine || isFromPart || isFromActivity) ? (
                  <Box sx={pageStyles.rightGridMachinePartSX}>
                    {showSearch && (<SearchField searchPlaceholder={searchPlaceholder} onSearch={onSearch} inputWidth={isFromPart ? { minWidth: '150px' } : { minWidth: '306px' }} />)}
                    {showSearch && !hideAddNewButton && <VrLine style={{ color: `${themeData.palette.customBorderColor.main}` }} />}
                    {!showSaveButton && !hideAddNewButton && (<AddButtonWithAccessCheck from='MasterComponent' addNewLabel={addNewLabel} onClick={addNewService} />)}
                    {showExport && (<FileExport entityName={entityName} exportData={exportData} isTemplate={isTemplate} exportFileName={fileName} />)}
                    {isFromMachine ? showImport && <Button variant='outlined'
                      startIcon={<ExcelIcon {...(!hasAccessTo.create && { style: {} })} />}
                      sx={{ height: '42px' }}
                      disabled={!hasAccessTo.create} onClick={openBulkPopup}>Import Excel/CSV</Button> : showImport && (<FileImport entityName={entityName} dataColumns={dataColumns} data={rows} uniqueParams={['machine_name', 'part_name']} excelSchema={excelSchema} action={imporAction} hasAccess={hasAccessTo.create} />)}
                    {showDownloadTemplate &&
                      <Box sx={{ ml: 0 }}>
                        <FileExport
                          entityName={entityName}
                          exportData={exportData}
                          isTemplate
                          exportFileName={fileName}
                        />
                      </Box>
                    }
                  </Box>
                ) : (
                  <Box sx={pageStyles.rightGridCommonPages}>
                    <Box sx={pageStyles.rightGridContainer}>
                      {/* {!showSaveButton && showSearch && (<Box sx={pageStyles.rightGridSearchBox}> <SearchField searchPlaceholder={searchPlaceholder} onSearch={onSearch} inputWidth={showImport ? { minWidth: '325px' } : tabSmallScreen ? { minWidth: '100%' } : { minWidth: '410px' }} /></Box>)} */}
                      {/* {showSearch && <VrLine style={{ marginLeft: '0px', marginRight: '16px', color: `${themeData.palette.customBorderColor.main}` }} />} */}
                      {!showSaveButton && showSearch && (<Box sx={{ ...pageStyles.rightGridSearchBox, mr: hideAddNewButton ? 0 : 2 }}> <SearchField searchPlaceholder={searchPlaceholder} onSearch={onSearch} inputWidth={showImport ? { minWidth: '325px' } : tabSmallScreen ? { minWidth: '100%' } : { minWidth: '300px' }} /></Box>)}
                      {showSearch && !hideAddNewButton && <VrLine style={{ marginLeft: '0px', marginRight: '16px', color: `${themeData.palette.customBorderColor.main}` }} />}
                      {showDeleteButton && (<Button variant='outlined' sx={{ marginRight: '16px' }} onClick={deleteData}> <DeleteOutlinedIcon sx={{ marginRight: 1 }} /> Delete Selected </Button>)}
                      {!showSaveButton && !hideAddNewButton && (<AddButtonWithAccessCheck from='MasterComponent' addNewLabel={addNewLabel} onClick={addNewService} />)}
                      {/* {showDownloadTemplate &&
                        <Box sx={{ ml: 2 }}>
                          <FileExport
                            entityName={entityName}
                            exportData={exportData}
                            isTemplate
                            exportFileName={fileName}
                          />
                        </Box>
                      } */}
                      {showSaveButton && (disableSaveButton ? (
                        <Tooltip componentsProps={{
                          tooltip: {
                            sx: {
                              borderRadius: '4px',
                              backgroundColor: themeData.palette.text.primary,
                              color: themeData.palette.primary.contrastText
                            },
                          },
                          arrow: {
                            sx: {
                              height: '8px',
                              width: '14px',
                              color: themeData.palette.text.primary,
                            },
                          },
                        }} title={disableSaveButtonTooltipText || ''} placement='top' arrow>
                          <Box component='span'><Button variant='contained' onClick={handleSave} sx={{ marginRight: '0px' }} disabled={disableSaveButton}><SaveOutlinedIcon sx={{ marginRight: 1 }} /> Save </Button></Box>
                        </Tooltip>
                      ) : (
                        <Button variant='contained' onClick={handleSave} sx={{ marginRight: '0px' }}> <SaveOutlinedIcon sx={{ marginRight: 1 }} /> Save </Button>
                      ))}
                    </Box>
                  </Box>)}
              </Grid>
            </Grid>
          )}
        </Box>
        <Divider />
        <Box>
          {loadCustomTable ? <CustomDataTable
            rows={rows}
            columns={columns}
            tableHeight='calc(100vh - 280px)'
            noRowsLabel="No Data Found"
            loading={isLoading}
            isServerPagination={isServerPagination}
            totalRowCount={totalRowCount}
            page={pageNumber}
            onPagination={onPagination}
            onSorting={onSorting}
            isExpandable={isExpandable}
            expandedRows={expandedRows}
          /> : <DataTable
            tableHeight={tableHeight}
            columns={
              isEmpty(actionsColumn)
                ? columns
                : [
                  ...columns,
                  {
                    field: 'actions',
                    headerName: 'Actions',
                    sortable: false,
                    headerAlign: 'center',
                    align: useCaseBuilerAccess ? selectedTab === 0 ? 'left' : 'center' : 'center',
                    width: actionsColumn.editDigitalTwin ? 180 : useCaseBuilerAccess ? 190 : 125,
                    renderCell: (params: GridValueGetterParams) => {
                      return (
                        <>

                          {!isEmpty(actionsColumn.visible) && (
                            <ViewIconButton
                              onClick={() => actionsColumn.visible.onClick(params)}
                              disabled={
                                (actionsColumn.visible.isDisabled && actionsColumn.visible.isDisabled(params)) ||
                                !hasAccessTo.read
                              }
                            />
                          )}
                          {!isEmpty(actionsColumn.edit) && (
                            <EditIconButton
                              onClick={() => actionsColumn.edit.onClick(params)}
                              disabled={
                                (actionsColumn.edit.isDisabled && actionsColumn.edit.isDisabled(params)) ||
                                !hasAccessTo.update
                              }
                            />
                          )}

                          {!isEmpty(actionsColumn.settings) &&
                            /(archit|vinayak)/i.test(auth?.user?.profile?.name ?? '') && (
                              <SettingsIconButton
                                onClick={() => actionsColumn.delete.onClick(params)}
                                disabled={
                                  (actionsColumn.visible.isDisabled && actionsColumn.visible.isDisabled(params)) ||
                                  !hasAccessTo.read
                                }
                              />
                            )}
                          {/* {!isEmpty(actionsColumn.edit) && (
                              <EditIconButton
                                onClick={() => actionsColumn.edit.onClick(params)}
                                disabled={
                                  (actionsColumn.edit.isDisabled && actionsColumn.edit.isDisabled(params)) ||
                                  !hasAccessTo.update
                                }
                              />
                            )} */}
                          {!isEmpty(actionsColumn.delete) && (
                            <DeleteIconButton
                              onClick={() => actionsColumn.delete.onClick(params)}
                              disabled={
                                (actionsColumn.delete.isDisabled && actionsColumn.delete.isDisabled(params)) ||
                                !hasAccessTo.delete
                              }
                            />
                          )}

                          {(useCaseBuilerAccess && params?.row?.use_case_category === 'dashboard') && (
                            <AccessButton
                              onClick={() => actionsColumn.access.onClick(params)}
                            />
                          )}


                          {/* {!isEmpty(actionsColumn.settings) &&
                              /(archit|vinayak)/i.test(auth?.user?.profile?.name ?? '') && (
                                <SettingsIconButton
                                  onClick={() => actionsColumn.delete.onClick(params)}
                                  disabled={
                                    (actionsColumn.settings.isDisabled && actionsColumn.settings.isDisabled(params)) ||
                                    !hasAccessTo.update
                                  }
                                />
                              )} */}
                          {/* {!isEmpty(actionsColumn.delete) && (
                              <DeleteIconButton
                                onClick={() => actionsColumn.delete.onClick(params)}
                                disabled={
                                  (actionsColumn.delete.isDisabled && actionsColumn.delete.isDisabled(params)) ||
                                  !hasAccessTo.delete
                                }
                              />
                            )} */}


                          {!isEmpty(actionsColumn.editDigitalTwin) && (
                            <EditDigitalTwin
                              onClick={() => actionsColumn.editDigitalTwin.onClick(params)}
                              disabled={
                                (actionsColumn.editDigitalTwin.isDisabled && actionsColumn.editDigitalTwin.isDisabled(params)) ||
                                !hasAccessTo.update
                              }
                            />
                          )}
                          {!isEmpty(actionsColumn.play) && (
                            <PlayButton
                              onClick={() => actionsColumn.play.onClick(params)}
                              disabled={
                                (actionsColumn.play.isDisabled && actionsColumn.play.isDisabled(params)) ||
                                !hasAccessTo.update
                              }
                            />
                          )}


                        </>
                      );
                    },
                  },
                  (actionsColumn.preview && {
                    field: 'preview',
                    headerName: '',
                    sortable: false,
                    width: 160,
                    minWidth: 160,
                    renderCell: (params: GridValueGetterParams) => {
                      return (<Button variant='outlined' disabled={
                        (actionsColumn.preview.isDisabled && actionsColumn.preview.isDisabled(params)) ||
                        !hasAccessTo.read
                      } onClick={() => actionsColumn.preview.onClick(params)}><PreviewIcon /> Preview</Button>)
                    }
                  })
                ].filter(Boolean)
            }
            rows={rows}
            pageSizeOptions={[5]}
            loading={isLoading}
            hideFooter={hideFooter || (rows && !rows.length) || totalRowCount < 11}
            checkboxSelection={checkboxSelection}
            showColumnFilters={showColumnFilters}
            disableRowSelectionOnClick={disableRowSelectionOnClick}
            onRowSelectionChange={onRowSelectionChange ? onRowSelectionChange : () => { }}
            onRowClick={onRowClick}
            pageSize={pageSize}
            otherProps={otherProps}
            hiddenColumns={hiddenColumns}
            selectionModel={selectionModel}
            isRowSelectable={isRowSelectable}
            isServerPagination={isServerPagination}
            totalRowCount={totalRowCount}
            pageNumber={pageNumber}
            onPagination={onPagination}
            onSorting={onSorting}
            noRowsOverlay={noRowsOverlay}
          />}
        </Box>
      </Paper>
    </Container >
  );
};

const mapStateToProps = (state: any) => ({
  userAccess: state.profile.userAccess,
});

export default connect(mapStateToProps)(MasterComponent);
